var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1eb53a",
    d: "M0 26.7h53.3V40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0099b5",
    d: "M0 0h53.3v13.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 12.8h53.3v14.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 13.6h53.3v12.8H0zm11.2-2.4a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0099b5",
    d: "M12.8 11.2a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.8 9.3-.3.9.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.8 9.3.3.9-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.7 10h-1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.7 10-.8.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.8 10 .8.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.8 10h1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.3 11-.3-.9-.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.3 11-.8-.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 11 .8-.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 11 .3-.9.5.1m-.2-4.8-.3 1 .4.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.8 5.4.3 1-.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.7 6.1h-1v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.7 6.1-.8.6-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.8 6.1.8.6.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.8 6.1h1v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.3 7.2-.3-1-.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.3 7.2-.8-.6.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 7.2.8-.6-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 7.2.3-1 .5.2m-.2-4.8-.3 1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.8 1.6.3 1h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.7 2.3h-1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.7 2.3-.8.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.8 2.3.8.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.8 2.3h1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.3 3.3-.3-.9-.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.3 3.3-.8-.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 3.3.8-.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 3.3.3-.9.5.2m3.6 6.7-.3.9.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.6 9.3.3.9-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.5 10h-1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.5 10-.8.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.7 10 .8.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.7 10h1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 11-.3-.9-.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 11-.8-.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25 11 .8-.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25 11 .3-.9.5.1m-.2-4.8-.3 1 .5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.6 5.4.3 1-.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.5 6.1h-1v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.5 6.1-.8.6-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.7 6.1.8.6.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.7 6.1h1v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 7.2-.3-1-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 7.2-.8-.6.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25 7.2.8-.6-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25 7.2.3-1 .5.2m-.2-4.8-.3 1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.6 1.6.3 1h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.5 2.3h-1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.5 2.3-.8.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.7 2.3.8.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.7 2.3h1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 3.3-.3-.9-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 3.3-.8-.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25 3.3.8-.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25 3.3.3-.9.5.2m3.6 6.7-.3.9.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.4 9.3.3.9-.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.4 10h-1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.4 10-.8.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.5 10 .8.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.5 10h1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30 11-.3-.9-.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30 11-.8-.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.9 11 .8-.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.9 11 .3-.9.4.1m-.2-4.8-.3 1 .5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.4 5.4.3 1-.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.4 6.1h-1v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.4 6.1-.8.6-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.5 6.1.8.6.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.5 6.1h1v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30 7.2-.3-1-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30 7.2-.8-.6.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.9 7.2.8-.6-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.9 7.2.3-1 .4.2m-.2-4.8-.3 1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.4 1.6.3 1h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.4 2.3h-1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.4 2.3-.8.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.5 2.3.8.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.5 2.3h1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30 3.3-.3-.9-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30 3.3-.8-.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.9 3.3.8-.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.9 3.3.3-.9.4.2M14 9.3l-.2.9.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14 9.3.4.9-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 10h-1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 10-.8.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.2 10 .7.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.2 10h1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.6 11-.2-.9-.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.6 11-.7-.5.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.5 11 .8-.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.5 11 .3-.9.5.1m3.7-.9-.4.9.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18 9.3.2.9-.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.8 10h-1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.8 10-.7.5-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17 10 .8.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 10h1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.5 11-.3-.9-.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.5 11-.8-.5.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.4 11 .7-.5-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.4 11 .2-.9.5.1M18 5.4l-.4 1 .5.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18 5.4.2 1-.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.8 6.1h-1v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.8 6.1-.7.6-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17 6.1.8.6.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 6.1h1v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.5 7.2-.3-1-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.5 7.2-.8-.6.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.4 7.2.7-.6-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.4 7.2.2-1 .5.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.7b933b73a971535fd67c1805203b0ace.svg";
export { ForwardRef as ReactComponent };